import { useEffect, useState } from 'react';

const REFRESH_MS = 30_000;


export function usePlayerCount(serverIp) {
  const [count, setCount] = useState('--');

  useEffect(() => {
    if (!serverIp) {
      setCount('0');
      return undefined;
    }

    let cancelled = false;

    async function update() {
      try {
        const response = await fetch(`https://api.mcsrvstat.us/2/${encodeURIComponent(serverIp)}`);
        const data = await response.json();

        if (!cancelled) {
          setCount(data?.online && data?.players ? String(data.players.online ?? 0) : '0');
        }
      } catch {
        if (!cancelled) setCount('0');
      }
    }

    update();
    const timer = setInterval(update, REFRESH_MS);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [serverIp]);

  return count;
}
